import React, {useLayoutEffect, useMemo, useState} from "react";
import BulkPriceChangeAffectedProductsTable from "../../../../../../../components/app-specific/bulk-price-change-affected-products-table";
import {Tab, Tabs} from "../../../../../../../components/base/Tabs";
import BulkPriceChangeReportAttemptedProductsTable from "./attempted-products";


const tabs = {
    affectedProducts: 'affectedParts',
    attemptedProducts: 'attemptedParts',
}

const tabsList = [
    {
        value: tabs.attemptedProducts,
        label: "Attempted Products",
    },
    {
        value: tabs.affectedProducts,
        label: "Affected Products",
    },
]

const affectedProductsDataGridSaveConfig = {
    name: 'BulkPriceChangeReportProductsAffectedProductsDataGrid',
    version: 1,
}
const attemptedProductsDataGridSaveConfig = {
    name: 'BulkPriceChangeReportProductsAttemptedProductsDataGrid',
    version: 1,
}

const BulkPriceChangeReportProducts = ({
                                           showAffectedProducts,
                                           attemptId,
                                           requestId,
                                           newLogs,
                                       }) => {
    const [tab, setTab] = useState(tabs.attemptedProducts);

    /**
     * With each change in the [tab] state value and [showAffectedProducts] prop value:
     * - if showAffectedProducts is set to false, and the tab is [affectedProducts] then changes the tab to [attemptedProducts]
     */
    useLayoutEffect(() => {
        if (!showAffectedProducts && tab === tabs.affectedProducts) {
            setTab(tabs.attemptedProducts);
        }
    }, [showAffectedProducts, tab])

    const content = useMemo(() => {
        switch (tab) {
            case tabs.attemptedProducts:
                return <BulkPriceChangeReportAttemptedProductsTable
                    requestId={requestId}
                    attemptId={attemptId}
                    newLogs={newLogs}
                    showAttempt={!attemptId}
                    saveConfig={attemptedProductsDataGridSaveConfig}
                />;
            case tabs.affectedProducts:
                return <BulkPriceChangeAffectedProductsTable
                    hideTitle
                    requestId={requestId}
                    saveConfig={affectedProductsDataGridSaveConfig}
                />;
            default:
                return <></>;
        }
    }, [requestId, tab, attemptId, newLogs])

    return (
        <>
            {
                showAffectedProducts &&
                <div className={'d-flex w-100 mb-3 mt-5'}>
                    <div className='w-100 flex-grow-1'>
                        <Tabs value={tab ?? false} onChange={(_, value) => setTab(value)}>
                            {
                                tabsList.map(e => (
                                    <Tab
                                        key={e.value}
                                        value={e.value}
                                        label={e.label}
                                    />
                                ))
                            }
                        </Tabs>
                    </div>
                </div>
            }
            {
                !showAffectedProducts &&
                <p className={'text-start w-100 text-md font-weight-semi-bold mb-3 mt-5'}>
                    {tabsList.find(e => e.value === tab)?.label ?? ""}
                </p>
            }
            {content}
        </>
    );
}

export default BulkPriceChangeReportProducts;
